import { Member } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import { MemberCard } from 'chat/members/views/card'
import { MembersList } from 'chat/members/views/list'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface Props {
  reactors: Member[] | undefined
}

export function ReactorsView({ reactors }: Props) {
  const styles = useStyles()

  if (!reactors) {
    return null
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <MembersList
          members={reactors ?? []}
          renderItem={({ item: member }) => <MemberCard member={member} />}
        />
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    padding: 10,
  },
  emptyContainer: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
